import { memo, type PropsWithChildren, type RefObject } from 'react';

import { MultiselectKeys } from '~/components/MultiselectKeys';
import {
  type MouseSelectableItem,
  type UseSelectedItemsMouseSelectionParams,
  useSelectedItemsMouseSelection,
} from '~/hooks/useSelectedItemsMouseSelection';

export type SelectedItemsMouseSelectionContainerProps = {
  containerRef: RefObject<HTMLElement>;
  itemsPositions: MouseSelectableItem[];
  scrollElementRef: UseSelectedItemsMouseSelectionParams['scrollElementRef'];
  minSelectionTopPosition?: UseSelectedItemsMouseSelectionParams['minSelectionTopPosition'];
};

export const SelectedItemsMouseSelectionContainer = memo(
  ({
    children,
    containerRef,
    itemsPositions,
    scrollElementRef,
    minSelectionTopPosition,
  }: PropsWithChildren<SelectedItemsMouseSelectionContainerProps>) => {
    const { DragSelection } = useSelectedItemsMouseSelection({
      containerRef,
      rowsPositions: itemsPositions,
      scrollElementRef,
      minSelectionTopPosition,
    });

    return (
      <>
        <DragSelection />
        {children}
        {/*
         * Cmd/Ctrl+A is not registered here. This container also wraps people,
         * canvases, content collections, and public showcases. See
         * `.agents/resources/select-all.md`.
         */}
        <MultiselectKeys />
      </>
    );
  },
);

SelectedItemsMouseSelectionContainer.displayName = 'SelectedItemsMouseSelectionContainer';
